import { createContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RouteConstants from '../../../constants/routeConstants.json';
import {
  deleteProductApi,
  productDetailsApi,
  productStatusChangeApi,
} from '../../../api/Api';
import { handleApiError } from '../../../constants/Constants';
export const ProductDetailsContext = createContext({});
export const ProductDetailsContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [productDetails, setProductDetails] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [statusChange, setStatusChange] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [statusValue, setStatusValue] = useState(0);
  const [successPopup, setSuccessPopup] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState('');
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const location = useLocation();
  const productId = location?.state?.id;
  const currentPage = location?.state?.page;
  const permissionAccess = JSON.parse(
    localStorage.getItem('permissions'),
  )?.filter(item => {
    return item.feature === '67b416502efc50c984271c7c';
  })[0];

  const statuses = [
    { _id: 'A', name: 'Active' },
    { _id: 'I', name: 'Inactive' },
  ];
  const currentTabValue = localStorage.getItem('tabValue');
  const productType =
    currentTabValue === '1'
      ? 'inverter'
      : currentTabValue === '2'
      ? 'battery'
      : 'comboProduct';

  const productTypeForStatusUpdateAndDelete =
    currentTabValue === '1'
      ? 'inverter'
      : currentTabValue === '2'
      ? 'battery'
      : 'combo';

  useEffect(() => {
    getProductDetails(productType, productId);
  }, [productId, productType]);

  // api for get product details
  const getProductDetails = async (type, id) => {
    try {
      setSpinnerStatus(true);
      const response = await productDetailsApi(type, id);
      if (response?.status === 200) {
        setSpinnerStatus(false);
        if (productType == 'inverter') {
          setProductDetails(response?.data?.data?.inverter);
          setSelectedStatus(response?.data?.data?.inverter?.status);
        }
        if (productType == 'battery') {
          setProductDetails(response?.data?.data?.battery);
          setSelectedStatus(response?.data?.data?.battery?.status);
        }
        if (productType == 'comboProduct') {
          setProductDetails(response?.data?.data?.comboProduct);
          setSelectedStatus(response?.data?.data?.comboProduct?.status);
        }
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage('');
        setErrorPopup(false);
        goToProductList();
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText,
        );
      }
    }
    setSpinnerStatus(false);
  };

  const goToProductList = () => {
    navigate(RouteConstants.LIST_PRODUCTS, { state: { page: currentPage } });
  };
  const editProduct = () => {
    navigate(RouteConstants.EDIT_PRODUCT, {
      state: { productData: productDetails, page: currentPage },
    });
  };

  // API product  delete
  const deleteProduct = async () => {
    try {
      setSpinnerStatus(true);
      const data = {
        type: productTypeForStatusUpdateAndDelete,
      };
      const response = await deleteProductApi(productId, data);
      if (response.data.statusCode === 200) {
        setDeleteAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(response.data.message);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText,
      );
      setDeletePopup(false);
      setDeleteAlert(false);
    }
    setSpinnerStatus(false);
  };
  const productToLogin = () => {
    navigate(RouteConstants.LOGIN);
  };
  const handleStatusChange = async e => {
    const newStatusId = e.target.value;
    setSpinnerStatus(true);

    try {
      const data = { status: newStatusId, type: productTypeForStatusUpdateAndDelete };
      const response = await productStatusChangeApi(data, productId);

      if (response.data.statusCode === 200) {
        setSelectedStatus(newStatusId);
        setDeleteAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(response.data.message);
        setStatusChange(true);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText,
      );
    }
    setSpinnerStatus(false);
  };
  const productTableList = () => {
    if (!statusChange) {
      navigate(RouteConstants.LIST_PRODUCTS);
    }
  };
  const providerValue = {
    permissionAccess,
    goToProductList,
    spinnerStatus,
    statuses,
    editProduct,
    deleteProduct,
    deleteAlert,
    setDeleteAlert,
    currentTabValue,
    productType,
    successPopup,
    setSuccessPopup,
    successPopupMessage,
    selectedStatus,
    productToLogin,
    statusValue,
    getProductDetails,
    productTableList,
    productDetails,
    handleStatusChange,
    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    buttonText,
  };
  return (
    <ProductDetailsContext.Provider value={providerValue}>
      {children}
    </ProductDetailsContext.Provider>
  );
};
